import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import ZoomControls from "../UI/ChartZoomControls";
import { useTheme } from "@emotion/react";
import BoxCharts from "../UI/BoxCharts";

function DriftMaxPTChart({
  driftMaxPTdata,
  driftMaxPTLabels,
  zoomOptions,
  chartRef,
  onResetZoom,
  onZoomPluse,
  onZoomMinus,
  onPanPluse,
  onPanMinus,
}) {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const theme = useTheme();

  const Draft_Max_PT_config = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: theme.palette.white.main,
        }
      },
      title: {
        display: true,
        text: "Drift Max PT",
        color: theme.palette.white.main,
      },
      zoom: zoomOptions,
    },
    scales: {
      x: {
        ticks: {
          color: theme.palette.white.main,
        }
      },
      y: {
        ticks: {
          color: theme.palette.white.main,
        }
      }
    }
  };
  // const Draft_Max_PT_data = {
  //   labels: driftMaxPTLabels,
  //   datasets: [
  //     {
  //       label: "Drift Max PT",
  //       data: driftMaxPTdata,
  //       borderColor: "rgba(185, 392, 100, 1)",
  //       backgroundColor: "rgba(185, 392, 100, 0.2)",
  //     },
  //   ],
  // };

  useEffect(() => {
    setChartData({
      labels: driftMaxPTLabels,
      datasets: [
        {
          label: driftMaxPTdata.length ? "Drift Max PT" : "",
          data: driftMaxPTdata,
          borderColor: driftMaxPTdata.length ? "rgba(185, 392, 100, 1)" : "rgba(0,0,0,0)",
          backgroundColor: driftMaxPTdata.length ? "rgba(185, 392, 100, 0.2)" : "rgba(0,0,0,0)",
        },
      ],
    });
  }, [driftMaxPTdata, driftMaxPTLabels]);

  return (
    <>
      <BoxCharts minHeight="380px" maxHeight="700px" >
        <Box sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          padding: 3
        }} >
          <Typography variant='h5' color="text.secondary" fontWeight={600} >Drift di piano nel tempo</Typography>
          <ZoomControls
            onResetZoom={onResetZoom}
            onZoomPluse={onZoomPluse}
            onZoomMinus={onZoomMinus}
            onPanPluse={onPanPluse}
            onPanMinus={onPanMinus}
          />
        </Box>
        <Line
          height={'100%'}
          options={Draft_Max_PT_config}
          data={chartData}
          ref={chartRef}
        />
      </BoxCharts>
    </>
  );
}

export default DriftMaxPTChart;
